var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageActionConfig,
          "left-side-class": "col-xl-5",
          page: _vm.pageConfig,
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      _vm._l(_vm.sampleLogs, function(sampleLog, index) {
        return _c("InnerPageMessage", {
          key: `job-sample-${index}`,
          staticClass: "mb-4",
          attrs: {
            "custom-background-color": _vm.getSampleLogStyles(sampleLog)
              .backgroundColor,
            "custom-border-color": _vm.getSampleLogStyles(sampleLog)
              .borderColor,
            "custom-color": _vm.getSampleLogStyles(sampleLog).color,
            "custom-icon": _vm.getSampleLogStyles(sampleLog).icon,
            "custom-icon-color": _vm.getSampleLogStyles(sampleLog).iconColor,
            "hyperlink-config": _vm.getHyperlinkConfig(sampleLog),
            message: _vm.jobSampleMessage(sampleLog),
            visible: true
          }
        })
      }),
      _vm.isCreateSampleMode
        ? _c("create-sample-card", {
            attrs: {
              "academic-year-options": _vm.filterOptions.academicYears,
              "area-options": _vm.availableAreaForCreateSample,
              "semester-type-options": _vm.filterOptions.semesters
            },
            on: {
              "on-close": _vm.setCreateSampleMode,
              "on-continue": _vm.onCreateSample
            }
          })
        : _vm._e(),
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { filters: _vm.filtersConfig },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          center: _vm.onChangeCenter,
          locationType: _vm.onChangeLocationType,
          municipality: _vm.onChangeMunicipality,
          provider: _vm.onChangeProvider,
          search: _vm.onSearchHandler
        },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _vm.showQuestionnaireIndicator
        ? _c("questionnaire-status-bar", {
            attrs: { catalog: _vm.questionnaireStatusCatalog }
          })
        : _vm._e(),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.isUniqueAreaTypeSelected
        ? _c(
            "action-button",
            {
              staticClass: "ml-2 px-4",
              attrs: {
                i: "fas fa-file-exclamation",
                type: "button",
                variant: "outline-success close-border mr-n3"
              },
              on: {
                click: function($event) {
                  return _vm.goToSampleDetailsHandler({
                    areaId: _vm.appliedFilters.areaId,
                    academicYearId: _vm.appliedFilters.academicYearId,
                    periodNumber: _vm.appliedFilters.semesterId
                  })
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.hyperlinkConfig.text) + " ")]
          )
        : _vm._e(),
      _vm.resultIsEmpty
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c(
          "div",
          { key: row.id, staticClass: "py-2" },
          [
            _c("result-row", {
              attrs: { data: row },
              on: { "on-cancel": _vm.onCancelHandler }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _c("div", { staticClass: "mb-5" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }